// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"da498c1a","453":"693027c8"}[chunkId] + ".chunk.js";
};